export const createDuplicateValidator = ({ mode, sourceList, requireSubTheme = false, enforceGlobal = false, globalSourceList = [] }) => {
  return (inputValue) => {
    const trimmed = (inputValue || '').trim();
    if (!trimmed) return 'Enter a tag name';

    if (enforceGlobal) {
      const existsGlobally = (globalSourceList || []).some(item => (item.display || '').toLowerCase() === trimmed.toLowerCase());
      if (existsGlobally) return 'Tag already exists';
    }

    return null;
  };
};


